/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getInvoiceAttachmentBuckets } from "api/services/invoice";
import { invoiceQueryKeys } from "./invoiceQueryKeys";

type GetInvoiceAttachmentBucketsOptions = {
  filters: any;
  options?: UseQueryOptions;
  queryFn?: any;
};

export const useGetInvoiceAttachmentBuckets = (data: GetInvoiceAttachmentBucketsOptions) =>
  useQuery({
    queryKey: invoiceQueryKeys.invoiceAttachmentBucketList(data.filters),
    queryFn: data.queryFn
      ? data.queryFn
      : ({ signal }) =>
          getInvoiceAttachmentBuckets({ params: data.filters, signal })
            .then((res) => res.data)
            .catch((err) => err),
    ...data.options,
  });
